module.exports = __webpack_public_path__ + "static/media/genisis22.c693c6c5.jpg";